import { mergeDeepRight } from 'ramda';

import {
  trackAddFavorite,
  trackClickCard,
  trackCreateFolder,
  trackDeleteFavorite,
  trackFolderNameClick,
  trackGoToApplicationForm,
  trackMyHomeTrapClick,
  trackMyHomeTrapShow,
  trackNewbuildingFiltersSelect,
  trackAddNewbuildingFavorite,
  trackDeleteNewbuildingFavorite,
  trackAddNewbuildingComparison,
  trackDeleteNewbuildingComparison,
  trackNewbuildingLinkClick,
  trackNewbuildingPromoHover,
  trackNotificationFolder,
  trackSaveToFolder,
  trackVideoPlaying,
  trackNewbuildingMyHomeTrapShow,
  trackNewbuildingMyHomeTrapClick,
  trackUpsaleCarouselEvent,
  trackMortgagePaymentClick,
  trackMortgagePaymentInfoShow,
  trackMortgagePaymentInfoLinkClick,
  trackSlidePhoto,
  trackNewbuildingPrizeBanner,
} from './analytics';
import { TAnalyticsMessagePayload } from '../../types';

export function eventSiteHandler([, eventParams]: TAnalyticsMessagePayload) {
  const { action, category, label, sc, products, page } = eventParams;

  switch (true) {
    case category === 'favorite' && action === 'add_from_list_mob':
      trackAddFavorite({ label, sc, products, page });
      break;
    case category === 'favorite' && action === 'remove_from_list_mob':
      trackDeleteFavorite({ label, sc, products, page });
      break;
    case category === 'favorite' && action === 'add_from_listing_in_map_JK':
      trackAddNewbuildingFavorite({ products, page });
      break;
    case category === 'favorite' && action === 'remove_from_listing_in_map_JK':
      trackDeleteNewbuildingFavorite({ products, page });
      break;
    case category === 'CompareJK' && action === 'Add':
      trackAddNewbuildingComparison({ label, products, page });
      break;
    case category === 'CompareJK' && action === 'Remove':
      trackDeleteNewbuildingComparison({ label, products, page });
      break;
    case category === 'Listing' && action === 'to_card':
      trackClickCard({ sc, products, page });
      break;
    case category === 'Listing' && action === 'slide_photo':
      trackSlidePhoto({ sc, products, page });
      break;
    case category === 'Listing' && action === 'to_card_newbuilding':
      trackNewbuildingLinkClick({ sc, products, page });
      break;
    case category === 'Listing' && action === 'show_sopr' && label === 'PromotionsJK':
      trackNewbuildingPromoHover({ label, products, page });
      break;
    case category === 'Listing' && action === 'Click' && String(label).startsWith('select_corpus'):
    case category === 'Listing' && action === 'Click' && ['developer', 'agent'].includes(label):
      trackNewbuildingFiltersSelect({ label, products, page });
      break;
    case category === 'Listing' && action === 'click' && label === 'upsale_carousel_to_card':
    case category === 'Listing' && action === 'show_sopr' && label === 'upsale_offers_carousel':
    case category === 'Listing' && action === 'click' && label === 'upsale_carousel_scroll':
      trackUpsaleCarouselEvent({ action, category, products, page, label });
      break;
    case category === 'ListingFavorites' && action === 'add_collection':
      trackCreateFolder({ label, sc, products, page });
      break;
    case category === 'ListingFavorites' && action === 'add_to_collection':
      trackSaveToFolder({ label, sc, products, page });
      break;
    case category === 'ListingFavorites' && action === 'click_collection_name':
      trackFolderNameClick({ label, sc, products, page });
      break;
    case category === 'ListingFavorites' && action === 'Click':
      trackNotificationFolder({ label, sc, products, page });
      break;
    case category === 'Map' && label === 'GoToApplicationForm/pin':
      trackGoToApplicationForm({ sc, products, page });
      break;
    case category === 'myhome' && action === 'show_sopr' && label === 'add_address':
      trackMyHomeTrapShow({ products, page });
      break;
    case category === 'myhome' && action === 'click' && label === 'add_address':
      trackMyHomeTrapClick({ products, page });
      break;
    case category === 'myhome' && action === 'show_sopr' && label === 'add_address_nb':
      trackNewbuildingMyHomeTrapShow({ products, page });
      break;
    case category === 'myhome' && action === 'click' && label === 'add_address_nb':
      trackNewbuildingMyHomeTrapClick({ products, page });
      break;
    case category === 'play_video' && action === 'show':
      trackVideoPlaying({ action, category, products, page: mergeDeepRight(page, eventParams.page) });
      break;
    case category === 'Listing' && action === 'click_sopr' && label === 'monthly_payment':
      trackMortgagePaymentClick({ action, category, label, sc, products, page });
      break;
    case category === 'Listing' && action === 'show_sopr' && label === 'about_payment_tooltip':
      trackMortgagePaymentInfoShow({ action, category, label, sc, products, page });
      break;
    case category === 'Listing' && action === 'click_sopr' && label === 'about_payment_details':
      trackMortgagePaymentInfoLinkClick({ action, category, label, sc, products, page });
      break;
    case category === 'trap' && ['show_sopr', 'click_sopr'].includes(action) && label === 'purchase_giveaway_banner':
      trackNewbuildingPrizeBanner(eventParams);
      break;
  }
}
